/**
 * OCHAT OVERLAY: es overrides, spread into one flat namespace map,
 * mirroring how upstream's locale/<locale>/index.js is built.
 *
 * Each file holds ONLY the keys where Ochat differs from upstream, so a diff
 * here reads as "what Ochat changed" instead of a whole retranslated locale.
 * See ../index.js for how these get merged in.
 */
import upstreamOrphans from './upstreamOrphans';
import advancedFilters from './advancedFilters.json';
import agentMgmt from './agentMgmt.json';
import automation from './automation.json';
import bookings from './bookings.json';
import cannedMgmt from './cannedMgmt.json';
import chatlist from './chatlist.json';
import components from './components.json';
import contact from './contact.json';
import conversation from './conversation.json';
import datePicker from './datePicker.json';
import general from './general.json';
import generalSettings from './generalSettings.json';
import guide from './guide.json';
import helpCenter from './helpCenter.json';
import inboxMgmt from './inboxMgmt.json';
import integrations from './integrations.json';
import labelsMgmt from './labelsMgmt.json';
import macros from './macros.json';
import marketing from './marketing.json';
import report from './report.json';
import search from './search.json';
import settings from './settings.json';
import signup from './signup.json';
import snooze from './snooze.json';
import teamsSettings from './teamsSettings.json';

export default {
  ...bookings,
  ...upstreamOrphans,
  ...advancedFilters,
  ...agentMgmt,
  ...automation,
  ...cannedMgmt,
  ...chatlist,
  ...components,
  ...contact,
  ...conversation,
  ...datePicker,
  ...general,
  ...generalSettings,
  ...guide,
  ...helpCenter,
  ...inboxMgmt,
  ...integrations,
  ...labelsMgmt,
  ...macros,
  ...marketing,
  ...report,
  ...search,
  ...settings,
  ...signup,
  ...snooze,
  ...teamsSettings,
};
